




































import Vue from "vue";
import { Component } from "vue-property-decorator";
import IdleTimer from "@/components/IdleTimer.vue";
import Upscope from "@/components/Upscope.vue";
import InsightPage from "@/pages/InsightPage.vue";
import { createNamespacedHelpers } from "vuex";
import PortalNotifications from "@/components/PortalNotifications.vue";
import UserLoginNotification from "@/components/UserLoginNotification.vue";
import Banner from "@/components/Banner.vue";
const { mapGetters } = createNamespacedHelpers("persistent");

@Component({
	components: {
		Upscope,
		IdleTimer,
		InsightPage,
		UserLoginNotification,
		PortalNotifications,
		Banner,
	},
	methods: {
		...mapGetters(["isLoggedIn", "allPermission"]),
	},
})
export default class App extends Vue {
	private readonly isLoggedIn!: () => boolean;
	private readonly allPermission!: () => any;

	private brand() {
		return process.env.VUE_APP_BRAND;
	}
	private isNewUrl() {
		// Check for Iress URL to bypass this in local and dev environments
		return !window.location.hostname.includes("superconnector.iress.com");
	}
}
